import { DocumentLists } from "@nju/feature-portal-documents";
import { Footer } from "@nju/feature-portal-footer";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function RegulationsAndPricesArchived() {
  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <BlockContent spacing="l">
        <DocumentLists
          title="archiwalne regulaminy i cenniki"
          validity="EXPIRED"
          variant="sales"
        />
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
